import React from 'react';
import { PhoneCall, MessageSquare, Calculator } from 'lucide-react';
import { motion } from 'framer-motion';
export function StepsSection() {
  const steps = [{
    num: '1',
    title: 'Call Us',
    desc: 'Reach out at (440) 222-1065. We actually answer the phone.',
    icon: <PhoneCall className="w-8 h-8" data-id="element-340" />
  }, {
    num: '2',
    title: 'Tell Us What You Need',
    desc: 'Share your vision, problems, or ideas for your outdoor space.',
    icon: <MessageSquare className="w-8 h-8" data-id="element-341" />
  }, {
    num: '3',
    title: 'Get a FREE Estimate',
    desc: 'We come out, look at your property, and give you a quote — no pressure, no obligation.',
    icon: <Calculator className="w-8 h-8" data-id="element-342" />
  }];
  return <section className="py-24 bg-gray-50 border-t border-gray-200" data-id="element-343">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-344">
        <div className="text-center mb-16" data-id="element-345">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-346">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4 uppercase tracking-wider text-sm text-[#1B4332]" data-id="element-347">
              Here's Your Next Step — It's Free
            </h2>
            <p className="text-3xl font-serif font-bold text-gray-900 mt-2" data-id="element-348">
              Getting started is simple and costs you nothing.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-349">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gray-200 -z-10 transform -translate-y-1/2" data-id="element-350"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 text-center relative" data-id="element-351">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rounded-full bg-[#C41E24] text-white flex items-center justify-center font-bold text-xl border-4 border-gray-50" data-id="element-352">
                {step.num}
              </div>

              <div className="w-16 h-16 mx-auto bg-[#FEFAE0] text-[#D4A373] rounded-full flex items-center justify-center mb-6 mt-4" data-id="element-353">
                {step.icon}
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-354">
                {step.title}
              </h3>
              <p className="text-gray-600" data-id="element-355">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center mt-12" data-id="element-356">
          <p className="text-xl font-medium text-gray-900" data-id="element-357">
            That's it. You have nothing to lose and a completely transformed
            outdoor space to gain.
          </p>
        </motion.div>
      </div>
    </section>;
}